export type WebsiteEditorSection = "hero" | "floating-button" | "middle-tabs" | "pages" | "menus" | "blog" | "footer" | "set-up" | "site-setup";

export const WEBSITE_EDITOR_SECTIONS: readonly WebsiteEditorSection[] = [
  "hero",
  "floating-button",
  "middle-tabs",
  "pages",
  "blog",
  "footer",
  "menus",
  "set-up",
  "site-setup",
];

export function websiteEditorDestination(section: WebsiteEditorSection = "hero"): string {
  const safeSection = WEBSITE_EDITOR_SECTIONS.includes(section) ? section : "hero";
  return `/website?tab=website&sub=${safeSection}`;
}
